import { useMemo, useEffect } from 'react';

type Brand = 'corbel' | 'returncatalyst';

interface BrandConfig {
  brand: Brand;
  name: string;
  tagline: string;
  logoInitials: string;
  pageTitle: string;
  description: string;
}

const CORBEL_CONFIG: BrandConfig = {
  brand: 'corbel',
  name: 'Corbel Capital',
  tagline: 'AI-Powered Due Diligence Platform',
  logoInitials: 'C',
  pageTitle: 'Corbel Capital AI',
  description: "AI-powered due diligence platform",
};

const RETURNCATALYST_CONFIG: BrandConfig = {
  brand: 'returncatalyst',
  name: 'ReturnCatalyst',
  tagline: 'Modular AI Software for PE Deal Operations',
  logoInitials: 'RC',
  pageTitle: 'ReturnCatalyst',
  description: "Modular AI software for PE deal operations and portfolio monitoring",
};

function detectBrand(): Brand {
  const hostname = window.location.hostname;
  if (
    hostname.includes('returncatalyst') ||
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.includes('corbel-ai-pipeline')
  ) {
    return 'returncatalyst';
  }
  return 'corbel';
}

export function useBrand(): BrandConfig {
  const config = useMemo(() => {
    const brand = detectBrand();
    return brand === 'returncatalyst' ? RETURNCATALYST_CONFIG : CORBEL_CONFIG;
  }, []);

  useEffect(() => {
    document.title = config.pageTitle;
  }, [config.pageTitle]);

  return config;
}
